import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "60",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "m20 12-8 8-8-8",
      style: {"stroke":"inherit"}
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#202030",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M44.374 20.63c-5.38 0-9.974.813-9.974 4.07s4.565 4.1 9.974 4.1c5.379 0 9.971-.815 9.971-4.07s-4.563-4.1-9.971-4.1M44.373 15.984a6.392 6.392 0 1 0-6.392-6.393 6.37 6.37 0 0 0 6.347 6.393z",
      "clip-rule": "evenodd",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }